import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { baseAssignmentsActions, baseAssignmentsSelectors, BaseCoreState } from '../../../_store';
import { BaseAssignmentsListPayloadInterface } from '../_interfaces/base-assignments-list-payload.interface';

@Injectable({ providedIn: 'root' })
export class BaseCustomerAllAssignmentsListGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseAssignmentsActions.loadCustomerAllAssignments({
        payload: route.queryParams as BaseAssignmentsListPayloadInterface,
      })
    );

    return this.store.select(baseAssignmentsSelectors.getAllCustomerAssignments).pipe(
      filter((state) => state.ok !== undefined),
      map((state) => state.ok as boolean)
    );
  }
}
